import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

const CaseCard = ({ caseItem }) => {
  const { language, buildPath } = useLanguage();
  const t = translations[language];
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="group relative bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
    >
      {/* Image */}
      <div className="relative h-64 md:h-80 overflow-hidden">
        <img
          src={caseItem.image}
          alt={caseItem.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        {/* Category tag */}
        <div className="absolute top-4 right-4">
          <span className="inline-block bg-[#ff5200] text-white text-xs font-semibold px-3 py-1 rounded-full">
            {caseItem.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl md:text-2xl font-bold text-black mb-3 group-hover:text-[#ff5200] transition-colors">
          {caseItem.title}
        </h3>
        <p className="text-gray-600 text-sm md:text-base mb-4 line-clamp-2">
          {caseItem.teaser}
        </p>
        <Link
          to={buildPath('caseDetail', { slug: caseItem.slug })}
          className="inline-flex items-center gap-2 text-[#ff5200] font-semibold hover:gap-3 transition-all duration-300"
        >
          {t.home.viewCase}
          <ArrowRight size={18} />
        </Link>
      </div>
    </motion.div>
  );
};

export default CaseCard;